export default function urlBreadcrumbs() {
    const breadcrumbContainer = document.getElementById('js-url-breadcrumbs');
    if (!breadcrumbContainer) return;

    const path = window.location.pathname
        .replace(/\/$/, '') // remove trailing slash
        .split('/')
        .filter(segment => segment.length > 0);

    let cumulativePath = '';

    path.forEach((segment, index) => {
        cumulativePath += '/' + segment;

        // Format display text
        const name = segment
            .replace(/-/g, ' ')
            .replace(/\b\w/g, char => char.toUpperCase());

        const li = document.createElement('li');
        li.classList.add('breadcrumbs-item');

        if (index === path.length - 1) {
            li.innerHTML = `
                <span class="breadcrumbs-text" aria-current="page">
                    ${name}
                </span>
            `;
        } else {
            li.innerHTML = `
                <a class="breadcrumbs-link" href="${cumulativePath}">
                    ${name}
                </a>
            `;
        }

        breadcrumbContainer.appendChild(li);
    });
}
